module.exports = __webpack_public_path__ + "static/group-7-a3f4235b822205477ea7ee23bebbfb8c.png";